import { KeyboardArrowLeft } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { COLORS } from "../../ui/Theme";

const MarketWatchTopGainersTitle = ({ title, url }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Typography sx={{ fontSize: "16px", fontWeight: 700 }}>
        {title}
      </Typography>

      <Link to={url}>
        <Typography
          sx={{
            color: COLORS.BLUE,
            fontSize: "14px",
            fontWeight: 900,
            display: "flex",
            alignItems: "center",
            padding: "4px 8px",
            borderRadius: "6px",
            gap: 0.5,
            "&:hover": {
              bgcolor: COLORS.SOFTBLUE,
            },
          }}
        >
          بیشتر
          <KeyboardArrowLeft sx={{ width: "20px" }} fontSize="small" />
        </Typography>
      </Link>
    </Box>
  );
};

export default MarketWatchTopGainersTitle;
